import { render, staticRenderFns } from "./addModifierOption.vue?vue&type=template&id=bb1751be&scoped=true&"
import script from "./addModifierOption.vue?vue&type=script&lang=js&"
export * from "./addModifierOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1751be",
  null
  
)

export default component.exports